import React from "react";

import {
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
} from "@material-ui/core";

import { WebTrackerResolutionType } from "../types";
import useAccountMetadata from "../../hooks/useAccountMetadata";
import {
  resolutionTypeAdjective,
  resolutionTypeImperative,
} from "./TrackerResolution";

const useStyles = makeStyles((_) => ({
  inputLabel: {
    transform: "translateX(14px) translateY(-5px) scale(0.75)",
  },
}));

export type ResolutionPickerProps = {
  value: WebTrackerResolutionType;
  onChange: (value: WebTrackerResolutionType) => void;
  disableBAA: boolean;
  trackerName: string;
};

function ResolutionPicker({
  value,
  onChange,
  disableBAA,
  trackerName,
}: ResolutionPickerProps) {
  const accountMeta = useAccountMetadata();
  const classes = useStyles();

  const isTrackerBlockingEnabled =
    accountMeta?.config.webTrackerMonitoringTrackerBlockedUI === true;

  const isResolutionFreshpaint = trackerName === "Freshpaint";

  return (
    <FormControl fullWidth>
      <InputLabel className={classes.inputLabel} id="resolution-picker-label">
        Resolution Type
      </InputLabel>
      <Select
        className="web-tracker-resolution-picker"
        label="Resolution Type"
        labelId="resolution-picker-label"
        onChange={(e) => onChange(e.target.value as WebTrackerResolutionType)}
        value={value}
        variant="outlined"
        renderValue={(value) =>
          resolutionTypeAdjective(value as WebTrackerResolutionType)
        }
      >
        <MenuItem value="unresolved">
          {resolutionTypeImperative("unresolved")}
        </MenuItem>
        <MenuItem disabled={disableBAA} value="signed_baa">
          {resolutionTypeImperative("signed_baa")}{" "}
          {disableBAA && `(not supported for ${trackerName})`}
        </MenuItem>
        <MenuItem value="marked_as_safe">
          {resolutionTypeImperative("marked_as_safe")}
        </MenuItem>
        <MenuItem disabled={isResolutionFreshpaint} value="marked_for_removal">
          {resolutionTypeImperative("marked_for_removal")}
        </MenuItem>
        <MenuItem
          disabled={isResolutionFreshpaint}
          value="replace_with_freshpaint"
        >
          {resolutionTypeImperative("replace_with_freshpaint")}
        </MenuItem>
        {isTrackerBlockingEnabled && (
          <MenuItem disabled={isResolutionFreshpaint} value="tracker_blocked">
            {resolutionTypeImperative("tracker_blocked")}
          </MenuItem>
        )}
        <MenuItem disabled={isResolutionFreshpaint} value="tracker_first_party">
          {resolutionTypeImperative("tracker_first_party")}
        </MenuItem>
      </Select>
    </FormControl>
  );
}

export default ResolutionPicker;
